import { useParams } from 'react-router-dom'

const useRoutePlatformId = () => {
  const { platformId } = useParams()
  return Number(platformId) || undefined
}

export default useRoutePlatformId
